import { SearchTerm } from "./SearchTerm";

const AccessGroupActionSearch: SearchTerm[] = [
    // { // api fails with an error
    //     heading: "Name",
    //     accessor: "name",
    //     searchOnName: "devAction.setting.nameOriginal",
    // },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "devAction.setting.settingType.trnName",
        translationKey: "type"
    },
    {
        heading: "Device",
        accessor: "device",
        searchOnName: "devAction.deviceImprox.devName",
        translationKey: "device"
    }
];

export default AccessGroupActionSearch;
